import React, { useEffect, useState } from "react";
import { reduxForm, Field } from "redux-form";
import { Grid, Header, Divider, Button } from "semantic-ui-react";
import { renderTextField } from "../formcomponents";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
const validate = (values) => {
  const errors = {};
  if (!values.visaCategory) {
    errors.workCvisaCategoryategory = "Required";
  }

  return errors;
};

const DeRecivedBankCreate = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const { id } = useParams();
  const userDetail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);
  useEffect(() => {
    if (id !== "null") {
      getWorkList();
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
    }
  }, []);
  const getWorkList = () => {
    axios
      .post(BaseUrl + "listSSVisaCategory", {
        ssVisaId: "",
        visaTypeNumber: 42569,
      })
      .then((res) => {
        console.log("res", res.data);
        const tempData = res.data;
        const filterData = tempData.filter((item) => item.visaCategoryId == id);
        console.log("filterData", filterData);

        initilizeData(filterData);
      })
      .catch((error) => console.log(error));
  };

  const initilizeData = (filterData) => {
    props.initialize({
      visaCategoryId: id,
      visaCategory: filterData[0].visaCategory,
    });
  };
  const sumbitForm = (values) => {
    console.log(values);
    const postObject = {
      ...values,
      visaTypeNumber: 42569,
    };
    axios
      .post(BaseUrl + "createSSVisaCategory", postObject)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errCode === 200) {
          Swal.fire({
            icon: "success",
            title: "sccess",
            text: "Created",
          });
          navigate(-1);
        } else if (res.data.errCode === 283) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "This Work Type Already Created",
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === "500") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "This Work Type Already Created",
          });
        }
      });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
         Create Recived Bank
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="two">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="visaCategory"
                label="Ticket Category"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Divider hidden />
      <>
        {" "}
        <Button
          floated="right"
          positive
          disabled={buttonDisable}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>{" "}
      </>
    </div>
  );
};

export default reduxForm({
  form: "DeRecivedBankCreate",
  validate,
})(DeRecivedBankCreate);
